const ADMIN = 'admin';
const BANKS = 'banks';

const notEmpty = (val) => {
    if (!val) return false
    return val !== ''
}
const encryptAdmin = (val) => {
    return window.btoa(val);
}
const decryptAdmin = (val) => {
    if (!val) return undefined;
    if (val.toString().charAt(0)===`"`){
        val = val.toString().slice(1, -1);
    }
    return JSON.parse(window.atob(val))
}

const getValue = (key) => {
    const value = localStorage.getItem(key);
    if (key === ADMIN){
        return decryptAdmin(value)
    }
    return value ? JSON.parse(value) : null;
}
const removeValue = (key) => {
    localStorage.removeItem(key);
}
const setValue = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
}

export const Storage = {
    setAdminUser: async (payload) => setValue(ADMIN, payload),
    getAdminUser: () => getValue(ADMIN),
    removeAdminUser: () => removeValue(ADMIN),
    getAgentName: () => {
        let details = getValue(ADMIN)
        if (!details) return null;
        return details.name;
    },
    getAgentID: () => {
        let details = getValue(ADMIN)
        if (!details) return null;
        return details.id;
    },
    getUserLevel: () => {
        let details = getValue(ADMIN)
        if (!details) return null;
        return details.level;
    },
    getUserCompany: () => {
        let details = getValue(ADMIN)
        if (!details) return null;
        return details.company;
    },
    isSuperAdmin: () => {
        let details = getValue(ADMIN)
        return details?.level === 'SUPERADMIN';
    },
    isAdmin: () => {
        let details = getValue(ADMIN)
        return details?.level === 'ADMIN';
    },

    setBanks: async (payload) => setValue(BANKS, payload),
    getBanks: async () => getValue(BANKS),
}
